import { axiosInstance} from '../../../api'
import { RequestModerationListedItemsProps, ResponseParams } from './types'

export const moderationPageItems = {
  async availableListedItems(
    query: RequestModerationListedItemsProps
  ): Promise<ResponseParams> {
    return axiosInstance
      .get('listed-items/public', { params: { ...query } })
      .then(({ data }) => data)
  }
}
